module.exports = __webpack_public_path__ + "img/RS_logo_white.72e9813e.png";